import { AppSettings } from 'app/app.settings';
import { AttrIndexService } from './attr-index.service';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import * as i0 from "@angular/core";
import * as i1 from "./attr-index.service";
import * as i2 from "./common-request.service";
import * as i3 from "./user.service";
var ExceptionService = /** @class */ (function () {
    function ExceptionService(attrIndexService, requestService, userService) {
        this.attrIndexService = attrIndexService;
        this.requestService = requestService;
        this.userService = userService;
    }
    ExceptionService.prototype.addException = function (layerId, uuid, colName, gqrCode, reason) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/exception';
            var body = {
                layerId: layerId,
                uuId: uuid,
                columnName: colName,
                gqrCode: gqrCode,
                reason: reason,
                sessionOwnerId: _this.userService.getUserInfo().userId
            };
            return _this.requestService.requestPost(url, body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    ExceptionService.prototype.deleteExceptioin = function (qxpId) {
        var _this = this;
        var url = AppSettings.serviceRootUrl + 'azgiv/exception';
        return new Promise(function (resolve, reject) {
            _this.requestService.requestDelete(url, {
                body: {
                    sessionOwnerId: _this.userService.getUserInfo().userId,
                    qxpId: qxpId
                }
            }, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    ExceptionService.prototype.getExceptions = function (layerId, globalIds) {
        var _this = this;
        var url = AppSettings.serviceRootUrl + 'azgiv/exception';
        return new Promise(function (resolve, reject) {
            _this.requestService.requestGet(url, {
                params: {
                    layerId: layerId,
                    globalIds: JSON.stringify(globalIds)
                }
            }, function (rsp) {
                var exceptions = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        exceptions.push({
                            id: d.qxp_id,
                            colName: d.qxp_col_name,
                            layerId: d.qxp_gly_id,
                            gqrCode: d.qxp_gqr_cd,
                            reason: d.qxp_reason,
                            tranxCreate: d.qxp_tranx_create,
                            recordUuid: d['qxp_' + _this.attrIndexService.globalIdColStandard],
                            value: null // will be filled in component
                        });
                    });
                }
                resolve(exceptions);
            }, function (err) { return reject(err); });
        });
    };
    ExceptionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExceptionService_Factory() { return new ExceptionService(i0.ɵɵinject(i1.AttrIndexService), i0.ɵɵinject(i2.CommonRequestService), i0.ɵɵinject(i3.UserService)); }, token: ExceptionService, providedIn: "root" });
    return ExceptionService;
}());
export { ExceptionService };
